import React, { useState, useEffect } from "react";
import "./Crossword.css";

const grids = [
  {
    clue: "Opposite of cold",
    answer: "HOT",
    positions: [
      { row: 0, col: 0 },
      { row: 0, col: 1 },
      { row: 0, col: 2 }
    ]
  },
  {
    clue: "A red fruit",
    answer: "APPLE",
    positions: [
      { row: 1, col: 0 },
      { row: 1, col: 1 },
      { row: 1, col: 2 },
      { row: 1, col: 3 },
      { row: 2, col: 0 }
    ]
  },
  {
    clue: "It flies in space",
    answer: "ROCKET",
    positions: [
      { row: 2, col: 0 },
      { row: 2, col: 1 },
      { row: 2, col: 2 },
      { row: 2, col: 3 },
      { row: 3, col: 0 },
      { row: 3, col: 1 }
    ]
  },
  {
    clue: "A yellow fruit",
    answer: "BANANA",
    positions: [
      { row: 0, col: 0 },
      { row: 1, col: 0 },
      { row: 2, col: 0 },
      { row: 3, col: 0 },
      { row: 3, col: 1 },
      { row: 3, col: 2 }
    ]
  },
  {
    clue: "Day after Monday",
    answer: "TUESDAY",
    positions: [
      { row: 0, col: 1 },
      { row: 1, col: 1 },
      { row: 2, col: 1 },
      { row: 3, col: 1 },
      { row: 3, col: 2 },
      { row: 2, col: 2 },
      { row: 1, col: 2 }
    ]
  },
  {
    clue: "Opposite of up",
    answer: "DOWN",
    positions: [
      { row: 0, col: 0 },
      { row: 1, col: 0 },
      { row: 2, col: 0 },
      { row: 3, col: 0 }
    ]
  },
  {
    clue: "A farm animal",
    answer: "COW",
    positions: [
      { row: 2, col: 1 },
      { row: 2, col: 2 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "Color of grass",
    answer: "GREEN",
    positions: [
      { row: 1, col: 0 },
      { row: 1, col: 1 },
      { row: 1, col: 2 },
      { row: 1, col: 3 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "It shines at night",
    answer: "MOON",
    positions: [
      { row: 0, col: 2 },
      { row: 1, col: 2 },
      { row: 2, col: 2 },
      { row: 3, col: 2 }
    ]
  },
  {
    clue: "Opposite of fast",
    answer: "SLOW",
    positions: [
      { row: 0, col: 1 },
      { row: 1, col: 1 },
      { row: 2, col: 1 },
      { row: 3, col: 1 }
    ]
  },
  {
    clue: "A pet animal",
    answer: "DOG",
    positions: [
      { row: 3, col: 0 },
      { row: 3, col: 1 },
      { row: 3, col: 2 }
    ]
  },
  {
    clue: "Opposite of dark",
    answer: "LIGHT",
    positions: [
      { row: 0, col: 0 },
      { row: 0, col: 1 },
      { row: 0, col: 2 },
      { row: 0, col: 3 },
      { row: 1, col: 3 }
    ]
  },
  {
    clue: "A flying insect",
    answer: "BEE",
    positions: [
      { row: 2, col: 0 },
      { row: 2, col: 1 },
      { row: 2, col: 2 }
    ]
  },
  {
    clue: "Color of sky",
    answer: "BLUE",
    positions: [
      { row: 1, col: 0 },
      { row: 1, col: 1 },
      { row: 1, col: 2 },
      { row: 1, col: 3 }
    ]
  },
  {
    clue: "Opposite of hot",
    answer: "COLD",
    positions: [
      { row: 3, col: 0 },
      { row: 3, col: 1 },
      { row: 3, col: 2 },
      { row: 3, col: 3 }
    ]
  },
  {
    clue: "It gives light",
    answer: "SUN",
    positions: [
      { row: 0, col: 0 },
      { row: 1, col: 0 },
      { row: 2, col: 0 }
    ]
  },
  {
    clue: "A big cat",
    answer: "LION",
    positions: [
      { row: 0, col: 1 },
      { row: 1, col: 1 },
      { row: 2, col: 1 },
      { row: 3, col: 1 }
    ]
  },
  {
    clue: "Opposite of old",
    answer: "NEW",
    positions: [
      { row: 2, col: 2 },
      { row: 2, col: 3 },
      { row: 3, col: 3 }
    ]
  },
  {
    clue: "A sweet food",
    answer: "CAKE",
    positions: [
      { row: 0, col: 2 },
      { row: 1, col: 2 },
      { row: 2, col: 2 },
      { row: 3, col: 2 }
    ]
  },

  {
    clue: "A fruit with spikes",
    answer: "KIWI",
    positions: [
      { row: 0, col: 0 },
      { row: 0, col: 1 },
      { row: 0, col: 2 },
      { row: 0, col: 3 }
    ]
  },
  {
    clue: "Opposite of tall",
    answer: "SHORT",
    positions: [
      { row: 1, col: 0 },
      { row: 1, col: 1 },
      { row: 1, col: 2 },
      { row: 1, col: 3 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "A bird that cannot fly",
    answer: "EMU",
    positions: [
      { row: 2, col: 0 },
      { row: 2, col: 1 },
      { row: 2, col: 2 }
    ]
  },
  {
    clue: "Color of lemon",
    answer: "YELLOW",
    positions: [
      { row: 0, col: 2 },
      { row: 1, col: 2 },
      { row: 2, col: 2 },
      { row: 3, col: 2 },
      { row: 3, col: 3 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "A sea animal",
    answer: "FISH",
    positions: [
      { row: 3, col: 0 },
      { row: 3, col: 1 },
      { row: 3, col: 2 },
      { row: 3, col: 3 }
    ]
  },
  {
    clue: "Opposite of happy",
    answer: "SAD",
    positions: [
      { row: 0, col: 1 },
      { row: 1, col: 1 },
      { row: 2, col: 1 }
    ]
  },
  {
    clue: "A fruit with seeds outside",
    answer: "STRAW",
    positions: [
      { row: 1, col: 0 },
      { row: 1, col: 1 },
      { row: 1, col: 2 },
      { row: 1, col: 3 },
      { row: 2, col: 0 }
    ]
  },
  {
    clue: "It barks",
    answer: "DOG",
    positions: [
      { row: 2, col: 0 },
      { row: 2, col: 1 },
      { row: 2, col: 2 }
    ]
  },
  {
    clue: "Opposite of night",
    answer: "DAY",
    positions: [
      { row: 0, col: 0 },
      { row: 1, col: 0 },
      { row: 2, col: 0 }
    ]
  },
  {
    clue: "A fruit monkeys love",
    answer: "MANGO",
    positions: [
      { row: 0, col: 3 },
      { row: 1, col: 3 },
      { row: 2, col: 3 },
      { row: 3, col: 3 },
      { row: 3, col: 2 }
    ]
  },
  {
    clue: "Opposite of big",
    answer: "SMALL",
    positions: [
      { row: 0, col: 2 },
      { row: 1, col: 2 },
      { row: 2, col: 2 },
      { row: 3, col: 2 },
      { row: 3, col: 1 }
    ]
  },
  {
    clue: "A fruit with crown",
    answer: "PINE",
    positions: [
      { row: 1, col: 0 },
      { row: 2, col: 0 },
      { row: 3, col: 0 },
      { row: 3, col: 1 }
    ]
  },
  {
    clue: "It has wheels",
    answer: "CAR",
    positions: [
      { row: 0, col: 1 },
      { row: 0, col: 2 },
      { row: 0, col: 3 }
    ]
  },
  {
    clue: "Opposite of wet",
    answer: "DRY",
    positions: [
      { row: 2, col: 1 },
      { row: 2, col: 2 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "A fruit with red skin",
    answer: "CHERRY",
    positions: [
      { row: 1, col: 0 },
      { row: 1, col: 1 },
      { row: 1, col: 2 },
      { row: 1, col: 3 },
      { row: 2, col: 3 },
      { row: 3, col: 3 }
    ]
  },


  {
    clue: "Precious yellow metal",
    answer: "GOLD",
    positions: [
      { row: 0, col: 0 },
      { row: 0, col: 1 },
      { row: 0, col: 2 },
      { row: 0, col: 3 }
    ]
  },
  {
    clue: "Opposite of begin",
    answer: "END",
    positions: [
      { row: 1, col: 0 },
      { row: 1, col: 1 },
      { row: 1, col: 2 }
    ]
  },
  {
    clue: "A fruit with crown",
    answer: "PINE",
    positions: [
      { row: 2, col: 0 },
      { row: 2, col: 1 },
      { row: 2, col: 2 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "It has keys but no locks",
    answer: "PIANO",
    positions: [
      { row: 3, col: 0 },
      { row: 3, col: 1 },
      { row: 3, col: 2 },
      { row: 3, col: 3 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "Opposite of empty",
    answer: "FULL",
    positions: [
      { row: 0, col: 1 },
      { row: 1, col: 1 },
      { row: 2, col: 1 },
      { row: 3, col: 1 }
    ]
  },
  {
    clue: "A bird that hoots",
    answer: "OWL",
    positions: [
      { row: 1, col: 2 },
      { row: 2, col: 2 },
      { row: 3, col: 2 }
    ]
  },
  {
    clue: "Opposite of high",
    answer: "LOW",
    positions: [
      { row: 0, col: 2 },
      { row: 1, col: 2 },
      { row: 2, col: 2 }
    ]
  },
  {
    clue: "A fruit with tiny seeds",
    answer: "FIG",
    positions: [
      { row: 0, col: 3 },
      { row: 1, col: 3 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "It tells time",
    answer: "CLOCK",
    positions: [
      { row: 3, col: 0 },
      { row: 2, col: 0 },
      { row: 1, col: 0 },
      { row: 0, col: 0 },
      { row: 0, col: 1 }
    ]
  },
  {
    clue: "Opposite of wrong",
    answer: "RIGHT",
    positions: [
      { row: 1, col: 1 },
      { row: 2, col: 1 },
      { row: 3, col: 1 },
      { row: 3, col: 2 },
      { row: 2, col: 2 }
    ]
  },
  {
    clue: "A fruit with segments",
    answer: "ORANGE",
    positions: [
      { row: 0, col: 2 },
      { row: 1, col: 2 },
      { row: 2, col: 2 },
      { row: 3, col: 2 },
      { row: 3, col: 3 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "It shines in sky",
    answer: "STAR",
    positions: [
      { row: 2, col: 0 },
      { row: 2, col: 1 },
      { row: 2, col: 2 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "Opposite of closed",
    answer: "OPEN",
    positions: [
      { row: 0, col: 0 },
      { row: 1, col: 0 },
      { row: 2, col: 0 },
      { row: 3, col: 0 }
    ]
  },
  {
    clue: "A fruit with purple skin",
    answer: "PLUM",
    positions: [
      { row: 1, col: 1 },
      { row: 1, col: 2 },
      { row: 1, col: 3 },
      { row: 2, col: 3 }
    ]
  },
  {
    clue: "Opposite of young",
    answer: "AGED",
    positions: [
      { row: 3, col: 0 },
      { row: 3, col: 1 },
      { row: 3, col: 2 },
      { row: 3, col: 3 }
    ]
  }
];








function getRandomGrid() {
  return grids[Math.floor(Math.random() * grids.length)];
}


export default function Crossword() {
  const [currentGrid, setCurrentGrid] = useState(getRandomGrid());
  const [userGrid, setUserGrid] = useState(
    Array.from({ length: 4 }, () => Array(4).fill(""))
  );
  const [message, setMessage] = useState("");
  const [score, setScore] = useState(0);

  const speak = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    speechSynthesis.speak(utterance);
  };

  const handleInput = (row, col, value) => {
    const newGrid = userGrid.map((r) => [...r]);
    newGrid[row][col] = value.toUpperCase();
    setUserGrid(newGrid);
  };

  const checkAnswer = () => {
    const word = currentGrid.positions.map(
      (pos) => userGrid[pos.row][pos.col]
    ).join("");
    if (word === currentGrid.answer) {
      setMessage("🎉 Correct!");
      setScore(score + 10);
      speak("Correct! The word is " + currentGrid.answer);
      setTimeout(() => loadNextPuzzle(), 2000);
    } else {
      setMessage("❌ Wrong!");
      setScore(score - 5);
      speak("Wrong! Try again.");
    }
  };

  const showAnswer = () => {
    const newGrid = userGrid.map((r) => [...r]);
    currentGrid.positions.forEach((pos, i) => {
      newGrid[pos.row][pos.col] = currentGrid.answer[i];
    });
    setUserGrid(newGrid);
    setMessage("💡 Answer revealed!");
    speak("The answer is " + currentGrid.answer);
  };

const loadNextPuzzle = () => {
  const nextGrid = getRandomGrid();
  const newGrid = Array.from({ length: 4 }, () => Array(4).fill(""));

  // Pick 1–2 random positions to prefill
  const prefillCount = Math.min(2, nextGrid.answer.length);
  const indices = [];
  while (indices.length < prefillCount) {
    const rand = Math.floor(Math.random() * nextGrid.answer.length);
    if (!indices.includes(rand)) indices.push(rand);
  }

  indices.forEach((i) => {
    const pos = nextGrid.positions[i];
    newGrid[pos.row][pos.col] = nextGrid.answer[i]; // put letter in grid
  });

  setCurrentGrid(nextGrid);
  setUserGrid(newGrid);  // ✅ ensures hints are visible
  setMessage("");
};


useEffect(() => {
  loadNextPuzzle(); // ✅ use the same logic for first puzzle
}, []);


  return (
    <div className="crossword-container">
      <h1>🧩 4x4 Crossword Grid</h1>
      <p className="clue">Clue: {currentGrid.clue}</p>

      <div className="grid">
        {userGrid.map((row, r) =>
          row.map((cell, c) => {
            const index = currentGrid.positions.findIndex(
              (pos) => pos.row === r && pos.col === c
            );
            const isHighlighted = index !== -1;
            return (
              <div key={`${r}-${c}`} className="cell-wrapper">
                {isHighlighted && (
                  <span className="cell-number">{index + 1}</span>
                )}
               <input
  className={`cell ${isHighlighted ? "highlight" : ""}`}
  maxLength={1}
  value={userGrid[r][c]}
  onChange={(e) => handleInput(r, c, e.target.value)}
  readOnly={userGrid[r][c] !== ""} // ✅ lock prefilled hints
/>


              </div>
            );
          })
        )}
      </div>

      <div className="buttons">
        <button className="submit-btn" onClick={checkAnswer}>
          Submit Word
        </button>
        <button className="hint-btn" onClick={showAnswer}>
          Show Answer
        </button>
        <button className="next-btn" onClick={loadNextPuzzle}>
          Next Puzzle ➡️
        </button>
      </div>

      <p className="status">{message}</p>
      <p className="score">⭐ Score: {score}</p>
    </div>
  );
}
